<template>
  <div class="question-wrapper" :id="id">
    <p class="text-subtitle1 question-title">
      <span class="label">{{number}}</span>
      <span>{{title}}</span>
    </p>
    <div ref="chart" :style="`height: ${chartHeight}px`" class="chart-wrapper"></div>
  </div>
</template>
<script>
import throttle from 'lodash.throttle'
import { setTimeout } from 'timers'

const echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/bar')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')


export default {
  data() {
    return {
      chart: null,
      chartHeight: 0,
      names: this.$props.yAxis,
      options: {
        color: ['#EA6300'],
        grid: {
          top: '20',
          left: '24',
          right: '16',
          bottom: '0',
        },
        title: {
          show: false
        },
        legend: {
          show: false
        },
        // tooltip: {
        //   // formatter: (params) => {
        //   //   return `${params.percent}`
        //   // }
        //   formatter: '{b}:{c}%)'
        // },
        yAxis: {
          show: true,
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          data: [],
          axisLabel: {
            show: false,
            inside: false,
            interval: 0,
            // rotate: 45,
            textStyle: {
              color: '#fff',
              fontSize: 12,
            },
          },
          z: 10
        },
        xAxis: {
          show: false,
          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              color: '#fff',
              fontSize: 14
            }
          }
        },
        series: [{
          // name: '票数',
          type: 'bar',
          data: [],
          // barCategoryGap: '25%',
          barWidth: 20,
          label: {
            normal: {
              show: true,
              position: [0, '-100%'],
              lineHeight: 20,
              textStyle: {
                color: '#fff',
                fontSize: 12,
              },
              formatter: params => {
                return `${this.names[params.dataIndex]}`
              }
            }
          }
        }],
      }
    }
  },
  props: {
    number: {
      type: [Number, String],
      default: () => null
    },
    id: {
      type: String,
      default: () => ''
    },
    title: {
      type: String,
      default: () => ''
    },
    yAxis: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      dafault: () => []
    }
  },
  mounted() {
    const barNumber = this.$props.yAxis.length
    this.chartHeight = barNumber * 20 + (barNumber - 1) * 35 + 20
  },
  methods: {
    initChart() {
      const wrapper = this.$refs.chart
      this.$nextTick(() => {
        this.options.yAxis.data = this.$props.yAxis
        this.options.series[0].data = this.$props.data
        this.chart = echarts.init(wrapper)
        this.chart.setOption(this.options)
      })

      window.addEventListener('resize', throttle(() => {
        this.chart.resize()
      }, 300))
    },
    setLabel(params) {
    }
  },
  watch: {
    chartHeight(val) {
      if (val > 0) {
        this.initChart()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
